'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('@babel/runtime/helpers/createClass'));
var _objectSpread = _interopDefault(require('@babel/runtime/helpers/objectSpread'));
var _typeof = _interopDefault(require('@babel/runtime/helpers/typeof'));
var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));

var handleApiFetchError = function handleApiFetchError(response) {
  return new Promise(function (resolve, reject) {
    if (!response || response.ok) {
      resolve(response);
    }

    var error;

    switch (response.status) {
      case 401:
        error = 'Unauthorized';
        break;

      case 403:
        error = 'Forbidden';
        break;

      case 404:
        error = 'Not Found';
        break;

      case 500:
        error = 'Internal Server Error';
        break;

      default:
        error = "Http Status Code ".concat(response.status);
        break;
    }

    var errorMessage = response.statusText && response.statusText.length > 0 ? " - ".concat(response.statusText) : '';
    reject(new Error(error + errorMessage));
  });
};

var ApiSource =
/*#__PURE__*/
function () {
  function ApiSource(urlPrefix, config) {
    var _this = this;

    _classCallCheck(this, ApiSource);

    _defineProperty(this, "getData", function (response) {
      if (!response) {
        return new Promise(function (resolve) {
          return resolve();
        });
      }

      if (response.statusText === 'No Content') {
        return new Promise(function (resolve) {
          return resolve();
        });
      }

      var resolveData;
      return new Promise(function (resolve) {
        resolveData = resolve;
        resolve(response.json());
      }).catch(function (err) {
        _this.logErrorOnJsonTransform(err);

        return _this.handleJsonTransformError(err, resolveData);
      });
    });

    _defineProperty(this, "handleJsonTransformError", function (err, resolve) {
      var invalidJsonMsg = 'Unexpected end of JSON input';

      if (err && err.message && err.message.indexOf(invalidJsonMsg) > -1) {
        console.warn('Consider updating your response code to 204 (No Content)');
        return resolve(); // just resolve w/ 'undefined'
      }

      throw err;
    });

    _defineProperty(this, "logErrorOnJsonTransform", function (err) {
      if (err && err.message) {
        console.error('ApiFetcher caught error:', err.message);
      }
    });

    _defineProperty(this, "getDefaultFetchOptions", function (method) {
      return {
        method: method,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json ; charset=utf-8'
        },
        credentials: 'include',
        mode: 'cors'
      };
    });

    this.urlPrefix = urlPrefix;
    this.config = config;
    this.fetchOptions = null;
  }

  _createClass(ApiSource, [{
    key: "call",
    value: function call(method, endpoint, body) {
      var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.config;
      var url = this.getRequestUrl(endpoint);
      var options = this.getRequestOptions(method, body);
      return this.fetchFromApi(url, options, config);
    }
  }, {
    key: "setFetchOptions",
    value: function setFetchOptions(fetchOptions) {
      if (fetchOptions && _typeof(fetchOptions) === 'object') {
        this.fetchOptions = fetchOptions;
      } else {
        console.error('You must provide an object to setFetchOptions');
      }
    }
  }, {
    key: "fetchFromApi",
    value: function fetchFromApi(url, options, config) {
      var _this2 = this;

      return fetch(url, options).then(function (response) {
        return _this2.onResponse(response, config);
      }).then(function (jsonData) {
        return _this2.onData(jsonData, config);
      });
    }
  }, {
    key: "onResponse",
    value: function onResponse(response, config) {
      var _this3 = this;

      var isValid = this.isValidConfig(config);

      if (isValid && typeof config.onResponse === 'function') {
        return config.onResponse(response);
      }

      return handleApiFetchError(response).then(function (r) {
        return _this3.getData(r);
      });
    }
  }, {
    key: "onData",
    value: function onData(jsonData, config) {
      var isValid = this.isValidConfig(config);

      if (isValid && typeof config.onData === 'function') {
        return config.onData(jsonData);
      }

      return jsonData;
    }
  }, {
    key: "isValidConfig",
    value: function isValidConfig(config) {
      return config && _typeof(config) === 'object';
    }
  }, {
    key: "getRequestOptions",
    value: function getRequestOptions(method, body) {
      var options = this.getFetchOptions(method);

      if (body) {
        options = Object.assign({}, options, {
          body: JSON.stringify(body)
        });
      }

      return options;
    }
  }, {
    key: "getFetchOptions",
    value: function getFetchOptions(method) {
      if (this.fetchOptions && this.userDidProvideValidOptions()) {
        return _objectSpread({
          method: method
        }, this.fetchOptions);
      }

      return this.getDefaultFetchOptions(method);
    }
  }, {
    key: "getRequestUrl",
    value: function getRequestUrl() {
      var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return "".concat(this.urlPrefix).concat(endpoint.trim());
    }
  }, {
    key: "userDidProvideValidOptions",
    value: function userDidProvideValidOptions() {
      return Object.keys(this.fetchOptions).length > 0;
    }
  }]);

  return ApiSource;
}();

/**
 *
 * @param {Promise} promise
 * @returns {Object}
 *
 * Produces object containing reference to resolved promise and
 * a "cancel" method that will force a rejection of the promise
 */
var makeCancelable = function makeCancelable(promise) {
  var hasCanceled_ = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled_ ? reject({
        isCanceled: true
      }) : resolve(val);
    }, function (error) {
      console.warn("Promise canceled: ".concat(error.message));
      hasCanceled_ ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled_ = true;
    }
  };
};

var ApiFetcher =
/*#__PURE__*/
function () {
  function ApiFetcher(urlPrefix, config) {
    _classCallCheck(this, ApiFetcher);

    this.api = new ApiSource(urlPrefix, config);
  }

  _createClass(ApiFetcher, [{
    key: "setFetchOptions",
    value: function setFetchOptions(fetchOptions) {
      this.api.setFetchOptions(fetchOptions);
    }
  }, {
    key: "get",
    value: function get(endpoint) {
      return this.api.call('GET', endpoint);
    }
  }, {
    key: "cancelableGet",
    value: function cancelableGet(endpoint) {
      return makeCancelable(this.get(endpoint));
    }
  }, {
    key: "post",
    value: function post(endpoint, body) {
      return this.api.call('POST', endpoint, body);
    }
  }, {
    key: "cancelablePost",
    value: function cancelablePost(endpoint, body) {
      return makeCancelable(this.post(endpoint, body));
    }
  }, {
    key: "del",
    value: function del(endpoint) {
      return this.api.call('DELETE', endpoint);
    }
  }, {
    key: "cancelableDel",
    value: function cancelableDel(endpoint) {
      return makeCancelable(this.del(endpoint));
    }
  }, {
    key: "call",
    value: function call(httpMethod, endpoint, body) {
      return this.api.call(httpMethod, endpoint, body);
    }
  }, {
    key: "cancelableCall",
    value: function cancelableCall(httpMethod, endpoint, body) {
      return makeCancelable(this.call(httpMethod, endpoint, body));
    }
  }, {
    key: "put",
    value: function put(endpoint, body) {
      return this.api.call('PUT', endpoint, body);
    }
  }, {
    key: "cancelablePut",
    value: function cancelablePut(endpoint, body) {
      return makeCancelable(this.put(endpoint, body));
    }
  }, {
    key: "revoke",
    value: function revoke(request) {
      if (request && typeof request.cancel === 'function') {
        request.cancel();
      }
    }
  }]);

  return ApiFetcher;
}();

exports.ApiFetcher = ApiFetcher;
exports.makeCancelable = makeCancelable;
